import { useState } from 'react';

interface VideoSectionProps {
  onNext: () => void;
}

export default function VideoSection({ onNext }: VideoSectionProps) {
  const [videoWatched, setVideoWatched] = useState(false);

  const features = [
    {
      icon: 'ri-robot-2-line',
      text: 'Yapay zeka destekli müşteri kazanımı'
    },
    {
      icon: 'ri-flow-chart',
      text: '3 aşamalı reklam sistemi'
    },
    {
      icon: 'ri-24-hours-line',
      text: '7/24 müşteri işleme'
    },
    {
      icon: 'ri-dashboard-3-line',
      text: 'Panel üzerinden yönetim'
    }
  ];

  return (
    <section className="min-h-screen flex items-center justify-center py-32 px-4 sm:px-6 lg:px-8 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-black via-gray-900 to-black"></div>
      
      <div className="relative z-10 max-w-6xl mx-auto w-full">
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Smart Hizmet Sistemi <span className="bg-gradient-to-r from-yellow-500 to-yellow-600 bg-clip-text text-transparent">Nasıl Çalışır</span>
          </h2>
          <p className="text-gray-400 text-lg">
            Sistemin tüm detaylarını öğrenmek için videoyu izleyin
          </p>
        </div>

        {/* Video Container */}
        <div className="bg-gradient-to-br from-gray-900 to-black border border-yellow-500/30 rounded-2xl p-6 sm:p-8 shadow-2xl shadow-yellow-500/10 mb-8">
          <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
            <iframe
              className="absolute top-0 left-0 w-full h-full rounded-xl"
              src="https://www.youtube.com/embed/4fNABMsDSEI"
              title="Smart Hizmet Sistemi"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-gray-900 to-black border border-white/10 rounded-xl p-6 hover:border-yellow-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-yellow-500/20"
            >
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className={`${feature.icon} text-2xl text-black`}></i>
                </div>
                <p className="text-white font-medium text-sm leading-tight">
                  {feature.text}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Checkbox */}
        <div className="bg-gradient-to-br from-gray-900 to-black border border-yellow-500/30 rounded-xl p-6 mb-6">
          <div 
            className="flex items-start gap-4 cursor-pointer"
            onClick={() => setVideoWatched(!videoWatched)}
          >
            <div className={`flex-shrink-0 w-6 h-6 rounded border-2 flex items-center justify-center cursor-pointer transition-all duration-300 ${
              videoWatched 
                ? 'bg-gradient-to-br from-yellow-500 to-yellow-600 border-yellow-500' 
                : 'border-white/30 bg-black/30'
            }`}>
              {videoWatched && (
                <i className="ri-check-line text-black text-lg font-bold"></i>
              )}
            </div>
            <label className="text-white font-medium cursor-pointer flex-1">
              Videoyu izledim ve Smart Hizmet sistemini anladım
            </label>
          </div>
        </div>

        {/* Next Button */}
        <button
          onClick={onNext}
          disabled={!videoWatched}
          className={`w-full py-4 rounded-lg font-bold text-lg transition-all duration-300 whitespace-nowrap ${
            videoWatched
              ? 'bg-gradient-to-r from-yellow-500 to-yellow-600 text-black hover:shadow-2xl hover:shadow-yellow-500/50 hover:scale-105 cursor-pointer'
              : 'bg-gray-700 text-gray-400 cursor-not-allowed'
          }`}
        >
          {videoWatched ? 'Videoyu İzledim Devam Et' : 'Önce Videoyu İzleyin'}
        </button>
      </div>
    </section>
  );
}